import { Breakpoint } from '@mui/material/styles';
import { ComponentProps } from 'react';
import { HeaderProp, TrimFlaggedPath, TrimFlaggedString } from './list-table.types';

export const getObjKeys = Object.keys as <T extends object>(obj: T) => Array<keyof T>;

export function getPath<T extends string, U extends TrimFlaggedPath<T>>(str: T): U | false {
  if (str[0] === ':') return str.slice(1) as U;
  return false;
}

export function getString<T extends string, U extends TrimFlaggedString<T>>(str: T): U | false {
  if (str[0] === '~') return str.slice(1) as U;
  return false;
}

export function renderCell<T extends Record<string, any>>(Component: React.FC<T>, props: T) {
  return <Component {...props} />;
}

export function createRender<T extends (...args: any) => JSX.Element>(Component: T, props: ComponentProps<T>) {
  return <Component {...props} />;
}

const breakpoints: Breakpoint[] = ['xs', 'sm', 'md', 'lg', 'xl'];
export function isWithinBreakpoint(
  currentBreakpoint: Breakpoint,
  maxBreakpoint?: Breakpoint,
  minBreakpoint?: Breakpoint,
  atBreakpoints?: Breakpoint[]
): boolean {
  if (maxBreakpoint) {
    if (breakpoints.indexOf(currentBreakpoint) > breakpoints.indexOf(maxBreakpoint)) {
      return false;
    }
  }
  if (minBreakpoint) {
    if (breakpoints.indexOf(currentBreakpoint) < breakpoints.indexOf(minBreakpoint)) {
      return false;
    }
  }
  if (maxBreakpoint && minBreakpoint) {
    return true;
  }
  if (atBreakpoints) {
    if (atBreakpoints.includes(currentBreakpoint)) {
      return true;
    } else {
      return false;
    }
  }
  return true;
}

export function renderHeader(header: HeaderProp) {
  if (typeof header === 'string') {
    return () => <>{header}</>;
  }
  return () => header.render();
}
